import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-balance-btn__left" }
const _hoisted_2 = { class: "user-balance-btn__user-icon" }
const _hoisted_3 = { class: "user-balance-btn__right" }
const _hoisted_4 = { class: "user-balance-btn__balance-value" }
const _hoisted_5 = { class: "user-balance__bold" }
const _hoisted_6 = { class: "user-balance-btn__balance-date-wrap" }
const _hoisted_7 = { class: "user-balance-btn__balance-date" }
const _hoisted_8 = { class: "user-balance-popup" }

import { logoutService } from "@/account/services/login-services";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import { StringHelper } from "@/helpers/string-helper";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { computed } from "vue";
import { PaperlessDatalayer } from "@/account/utils/analytics/paperless-datalayer";


export default /*@__PURE__*/_defineComponent({
  __name: 'user-balance',
  props: {
    userBalancePopupVisible: { type: Boolean },
    withdrawableAmount: {},
    withdrawalExpiration: {}
  },
  emits: ["toggle-user-balance-popup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const logoutClickHandler = async () => {
    await logoutService();
};

const balanceValueText = computed(() => StringHelper.toCurrencyString(props.withdrawableAmount).replace(/ /g, ""));
const balanceDateText = computed(() =>
    props.withdrawalExpiration ? DateTimeUtils.formatDate(new Date(props.withdrawalExpiration)) : "-"
);

const myReceiptsClickHandler = () => {
    PaperlessDatalayer.openMyReceipts();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", {
      class: "user-balance-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-user-balance-popup')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(KasaIcon, { name: "user" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createTextVNode(" Zůstatek: ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(balanceValueText.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createTextVNode(" Pouze do: ")),
          _createElementVNode("span", _hoisted_7, _toDisplayString(balanceDateText.value), 1)
        ])
      ])
    ]),
    _createVNode(TransitionFade, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("section", _hoisted_8, [
          _createElementVNode("a", {
            href: "/sazka-klub/moje-uctenky",
            class: "user-balance-popup__link",
            type: "button",
            onClick: myReceiptsClickHandler
          }, "Moje účtenky"),
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            href: "/sazka-klub/nastaveni",
            class: "user-balance-popup__link"
          }, "Nastavení účtu", -1)),
          _createElementVNode("a", {
            class: "user-balance-popup__link btn-logout",
            onClick: logoutClickHandler
          }, "Odhlásit se")
        ], 512), [
          [_vShow, _ctx.userBalancePopupVisible]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})